import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Recommendations').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    width: '90%',
    height: '100%',
  },

  title: {
    fontSize: theme.sizes.texts.fontSize.l,
    fontWeight: 550,
    color: theme.colors.text.primary,
    margin: '0px',
    lineHeight: theme.sizes.texts.lineHeight.l,
  },
  subtitle: {
    fontSize: theme.sizes.texts.fontSize.s,
    fontWeight: 400,
    color: theme.colors.text.secondary,
    margin: '0px',
    lineHeight: theme.sizes.texts.lineHeight.m,
    textAlign: 'center',
  },
  content: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
  },
}))
